import baseRadioForm from 'formiojs/components/radio/Radio.form';

// console.log(baseRadioForm);

export default baseRadioForm;
